export function ProgressBar({ value = 0 }) {
    const pct = Math.max(0, Math.min(100, value));
    return (
        <div className="w-full bg-blue-200 rounded-lg h-3 overflow-hidden my-1">
            <div
                className="h-full rounded-lg transition-all duration-300 bg-gradient-to-r from-primary-200 to-primary-400"
                style={{ width: `${pct}%` }}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={pct}
                role="progressbar"
            />
        </div>
    );
}
